import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { getLastAppHome } from "@/utils/appNavigation";

const routes = [
    {
        path: "/sign/:token",
        component: () => import("@/pages/SignaturePage.vue"),
        meta: { title: "合同电子签署｜章简合知识产权", noindex: true },
    },
    {
        path: "/",
        component: () => import("@/pages/Site-Portal.vue"),
        meta: { title: "章简合知识产权｜专业商标服务与复杂案件解决方案" },
    },
    {
        path: "/site-preview",
        redirect: "/",
    },
    {
        path: "/login",
        component: () => import("@/pages/LoginPage.vue"),
        meta: { title: "登录｜章简合知识产权", noindex: true },
        children: [],
    },
    {
        path: "/reset-password",
        component: () => import("@/pages/ResetPassword.vue"),
        meta: { title: "设置新密码｜章简合知识产权", noindex: true },
    },
    {
        path: "/home",
        component: () => import("@/pages/HomePage.vue"),
        meta: { title: "管理中心｜章简合知识产权", noindex: true },
        children: [
            {
                path: "",
                redirect: () => getLastAppHome(),
            },
            {
                path: "account",
                component: () => import("@/pages/Account.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            }, {
                path: "account/edit",
                component: () => import("@/pages/AccountEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "account/team-roles",
                component: () => import("@/pages/AccountTeamRoles.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "客户服务团队职责说明｜章简合知识产权", noindex: true },
            },
            {
                path: "product",
                component: () => import("@/pages/Product2.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "产品管理｜章简合知识产权", noindex: true },
            },
            {
                path: "product/edit",
                component: () => import("@/pages/Product2Edit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "产品详细信息｜章简合知识产权", noindex: true },
            },
            {
                path: "pricebook",
                component: () => import("@/pages/Pricebook.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "价格簿管理｜章简合知识产权", noindex: true },
            },
            {
                path: "pricebook/edit",
                component: () => import("@/pages/PricebookEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "价格簿详细信息｜章简合知识产权", noindex: true },
            },
            {
                path: "customer-tier",
                component: () => import("@/pages/CustomerTierSetup.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], requiredPermission: "customizeApplication", title: "客户分级｜章简合知识产权", noindex: true },
            },
            {
                path: "industry-library",
                component: () => import("@/pages/IndustryLibrarySetup.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], requiredPermission: "customizeApplication", title: "行业库｜章简合知识产权", noindex: true },
            },
            {
                path: "lead-sla",
                component: () => import("@/pages/LeadSlaSetup.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "Lead SLA 配置｜章简合知识产权", noindex: true },
            },
            {
                path: "case-workflow-setup",
                component: () => import("@/pages/CaseWorkflowSetup.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "案件工期规则｜章简合知识产权", noindex: true },
            },
            {
                path: "nice-classification",
                component: () => import("@/pages/NiceClassificationSetup.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "商品服务分类｜章简合知识产权", noindex: true },
            },
            {
                path: "sales-document-setup",
                component: () => import("@/pages/SalesDocumentSetup.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "报价与合同工作流｜章简合知识产权", noindex: true },
            },
            {
                path: "approval-process",
                component: () => import("@/pages/ApprovalProcessSetup.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "审批流程配置｜章简合知识产权", noindex: true },
            },
            {
                path: "approval-inbox",
                component: () => import("@/pages/ApprovalInbox.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "我的待审批｜章简合知识产权", noindex: true },
            },
            {
                path: "opportunity",
                component: () => import("@/pages/Opportunity.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "商机｜章简合知识产权", noindex: true },
            },
            {
                path: "opportunity/edit",
                component: () => import("@/pages/OpportunityEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "商机详细信息｜章简合知识产权", noindex: true },
            },
            {
                path: "quote",
                component: () => import("@/pages/Quote.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "报价｜章简合知识产权", noindex: true },
            },
            {
                path: "quote/edit",
                component: () => import("@/pages/QuoteEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "报价单｜章简合知识产权", noindex: true },
            },
            {
                path: "contract",
                component: () => import("@/pages/Contract.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "合同｜章简合知识产权", noindex: true },
            },
            {
                path: "contract/edit",
                component: () => import("@/pages/ContractEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "合同详情｜章简合知识产权", noindex: true },
            },
            {
                path: "task",
                component: () => import("@/pages/Task.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "任务｜章简合知识产权", noindex: true },
            },
            {
                path: "delivery/overview",
                component: () => import("@/pages/DeliveryHome.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "交付首页｜章简合知识产权", noindex: true },
            },
            {
                path: "delivery",
                component: () => import("@/pages/IpDelivery.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "知识产权案件交付｜章简合知识产权", noindex: true },
            },
            {
                path: "file",
                component: () => import("@/pages/CaseFile.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "文件中心｜章简合知识产权", noindex: true },
            },
            {
                path: "file/editor",
                component: () => import("@/pages/CaseFileEditor.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "在线编辑｜章简合知识产权", noindex: true },
            },
            {
                path: "lead",
                component: () => import("@/pages/Lead.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"], title: "Lead 管理｜章简合知识产权", noindex: true },
            },
            {
                path: "lead/edit",
                component: () => import("@/pages/LeadEdit.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"], title: "Lead 详细信息｜章简合知识产权", noindex: true },
            },
            {
                path: "index",
                component: () => import("@/pages/IndexPage.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "report",
                component: () => import("@/pages/ReportDashboard.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "销售分析｜章简合知识产权", noindex: true },
            },
            {
                path: "site-analytics",
                component: () => import("@/pages/SiteAnalytics.vue"),
                meta: { requiresAuth: true, requiredPermission: "viewSetup", title: "网站访问统计｜章简合知识产权", noindex: true },
            },
            {
                path: "territory",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "territory/edit",
                component: () => import("@/pages/UserRoleSetupStandard.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "profile",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "profile/edit",
                component: () => import("@/pages/SetupObjectEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "record-type",
                redirect: "/home/object",
            },
            {
                path: "record-type/edit",
                redirect: "/home/object",
            },
            {
                path: "case-page-layout",
                redirect: "/home/object",
            },
            {
                path: "object/page-layout",
                redirect: "/home/object",
            },
            {
                path: "object",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "object/edit",
                component: () => import("@/pages/SetupObjectEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "permission-set",
                component: () => import("@/pages/PermissionSet.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "email-settings",
                component: () => import("@/pages/EmailSettings.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], requiredPermission: "manageEmailSettings", title: "邮件设置｜章简合知识产权", noindex: true },
            },
            {
                path: "email-template",
                component: () => import("@/pages/EmailTemplate.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], requiredPermission: "manageEmailSettings", title: "邮件模板｜章简合知识产权", noindex: true },
            },
            {
                path: "model-management",
                component: () => import("@/pages/ModelManagement.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], requiredPermission: "customizeApplication", title: "模型管理｜章简合知识产权", noindex: true },
            },
            {
                path: "user-role",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "user-role/edit",
                component: () => import("@/pages/UserRoleSetupStandard.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "me",
                component: () => import("@/pages/MyProfile.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "个人资料｜章简合知识产权", noindex: true },
            },
            {
                path: "user",
                component: () => import("@/pages/UserManagement.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], requiredPermission: "manageUsers" },
            },
            {
                path: "user/edit",
                component: () => import("@/pages/UserSetupStandard.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], requiredPermission: "manageUsers" },
            },
            {
                path: "security",
                component: () => import("@/pages/AccountSecurity.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "账号安全｜章简合知识产权", noindex: true },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.afterEach((to) => {
    document.title = to.meta.title || "章简合知识产权";

    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.setAttribute("name", "robots");
        document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute(
        "content",
        to.meta.noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large"
    );
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    const permissions = authStore.systemPermissions || {};
    const hasRequiredPermission = !to.meta.requiredPermission
        || Boolean(permissions[to.meta.requiredPermission]);

    // 如果目标页面需要登录 && 没有 Token，则跳转到登录页
    if (to.meta.requiresAuth && !authStore.token) {
        next("/login");
    } else if (!hasRequiredPermission) {
        next("/home/index");
    } else {
        next(); // 继续访问
    }
});

export default router;
